import React from 'react';

import {Navigate} from 'react-router-dom';

import {SelectionComponent} from '../components/SelectionComponent';

import {Loader} from '@mantine/core';

import {ActivityIndicator} from 'components/ActivityIndicator';

import FederatedIdProvider from 'features/federated-id-providers/models/FederatedIdProvider';
import {useAccount} from 'hooks/useAccount';

import {authorizeUrlHelper} from 'utils/AuthorizeUrlHelper';
import {update} from 'services/AccountsService';

import {useDefaultSigninOption} from 'hooks/useDefaultSigninOption';

let provider = new FederatedIdProvider();

const updateAndRedirectForAuthorization = async (account) => {
    let authorizeUrl = await authorizeUrlHelper(account);
    const flagged = Object.assign({}, account, {
        isAuthorizing: 'yes',
    });

    update(account.id, flagged).then(() => {
        window.location.assign(authorizeUrl);
    });

};

export const IndexPage = () => {
    const account = useAccount();

    const {defaultOption} = useDefaultSigninOption();

    if (typeof defaultOption === 'undefined') {
        throw new Error('Sign in options is required parameter');
    }

    if (!Object.prototype.hasOwnProperty.call(defaultOption, 'password_and_sso')) {
        throw new Error('password_and_sso required parameter');
    }

    const {password_and_sso} = defaultOption;

    if (typeof account !== 'undefined') {
        if (provider.hasIdProvider(account) === true) {
            if (password_and_sso === true) {
                return (
                    <SelectionComponent
                        handleSSOButtonClick={() =>
                            updateAndRedirectForAuthorization(account)
                        }
                    />
                );
            } else {
                updateAndRedirectForAuthorization(account);
                return <ActivityIndicator label="Signing In...Please wait"/>;
            }
        } else {
            return <Navigate to={`/credentials/${account.id}`}/>;
        }
    } else {
        return <Loader/>;
    }
};
